import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'
import * as localStorage from "@/require/auth";
Vue.use(VueRouter)

// 解决vue-router在3.0版本以上重复点击路由报错的问题
// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }

const Index = () =>
    import ('@/views/index.vue')
const List = () =>
    import ('@/views/lists/list.vue')
const ListChannel = () =>
    import ('@/views/lists/listChannel.vue')
const ListLeaf = () =>
    import ('@/views/lists/listLeaf.vue')
const Introduce = () =>
    import ('@/views/introduce.vue')

const routes = [{
    path: '/',
    component: Index,
    name: 'home'
}, {
    path: '/list',
    component: List,
    children: [{
            path: 'listChannel',
            component: ListChannel,
        },
        {
            path: 'listLeaf',
            component: ListLeaf,
        }
    ]
}, {
    path: '/introduce',
    component: Introduce,
}]
const router = new VueRouter({
    routes
})

// 监听用户的登录状态[目的是和国研网的登录状态达成一致]
router.beforeEach((to, from, next) => {
    // 埋点系统 start
    try {
        if (LogCollection) {
            LogCollection.end()
        }
    } catch (e) {}

    // 埋点系统 end
    $.ajax({
        // url: 'http://pay.drcnet.com.cn/eDRCnet.common.web/login.ashx?flag=init',
        url: 'http://user.drcnet.com.cn/userapi/loginController/initLoginP',
        type: 'get',
        responseType: 'application/json',
        dataType: 'jsonp',
        jsonpCallback: 'showData',
        xhrFields: {
            withCredentials: true
        },
        success: function(data) {
            if (data.Logined === 0) {
                localStorage.removeName();
                localStorage.removeToken();
                store.commit('updateCultureState', false)
            } else {
                localStorage.setName(data.UserName)
                localStorage.setToken(data.UserToken)
                store.commit('updateCultureState', true)
            }
        }
    })
    next()
})

// 埋点系统 start
router.afterEach((to, from, next) => {
        try {
            if (LogCollection) {
                LogCollection.init()
            }
        } catch (e) {}

    })
    // 埋点系统 end

export default router